import React, { PropsWithChildren } from "react";
import {
  AddFavoriteQueryBtn,
  EditFavoriteQueryBtn,
  ShareQueryBtn,
  SuggestionsBtn
} from "./action-buttons";
import QuickSearchQueryBtn from "./action-buttons/QuickSearchQueryBtn";
import GlobalSearchButton from "./GlobalSearchButton";
import { IGlobalSearchButtons } from "./@types";
import { SEARCH_MODALS_NAMES } from "../../search/hooks/useSearchModals";

const GlobalSearchButtons = ({
  children,
  isLoading,
  isSearchQuery,
  isSearchValueWithinLimit,
  matchedFavourite,
  isActive,
  onClick,
  isLayoutStatic
}: PropsWithChildren<IGlobalSearchButtons>) => {
  const isDisabled = !(isSearchQuery && isSearchValueWithinLimit);

  const overLimitLabel = !isSearchValueWithinLimit
    ? "Query exceeds length limit (10000 characters)"
    : "";

  return (
    <div
      className={`search__buttons-container ${
        isActive ? "search__buttons-container--active" : ""
      }`}
    >
      {children}
      <QuickSearchQueryBtn onClick={onClick} />
      {isLayoutStatic && <SuggestionsBtn onClick={onClick} />}
      <span className="search__button-separator" />
      {(isActive || isLayoutStatic) && (
        <div className="search__optional-buttons">
          <ShareQueryBtn
            disabled={isDisabled}
            label={overLimitLabel}
            onClick={onClick}
          />
          {matchedFavourite ? (
            <EditFavoriteQueryBtn
              onClick={({ type }) =>
                onClick({ type, favourite: matchedFavourite })
              }
            />
          ) : (
            <AddFavoriteQueryBtn
              disabled={isDisabled}
              label={overLimitLabel}
              onClick={onClick}
            />
          )}
        </div>
      )}
      <GlobalSearchButton
        isLoading={isLoading}
        showTooltip={!isSearchQuery}
        onClick={() => onClick({ type: SEARCH_MODALS_NAMES.SEARCH })}
      />
    </div>
  );
};

export default GlobalSearchButtons;
